module.exports = __webpack_public_path__ + "static/senior-3-e069160a41155f0d4369e733e99242c7.png";